import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import globals from '#utilities/js/ea/globals.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onButtonClick = object(listener, {
  type: click,
  passive,
  task: (element, event) => {
    globals.ea_menu_bar(event)
  }
})
export default button => {
  onButtonClick.listen(button)
}
